import { AuthMemberCard } from '@tribeplatform/react-components/AuthMemberCard'

import { useSlateKitContext } from '../../hooks/index.js'
import { BC } from '../../types/index.js'

export const AuthMemberCardBlock: BC<Record<string, never>> = ({ ...rest }) => {
  const {
    context: { memberBannerPlaceholders },
  } = useSlateKitContext()
  return (
    <AuthMemberCard placeholderBanners={memberBannerPlaceholders} {...rest} />
  )
}
